<template>
<div class="formulaValidationClass">
      <el-form size="mini">
        <el-form-item label="校验规则说明">
              <el-tag>目前仅支持数字类型的字段进行验证，假如当前字段值不满足校验规则，则当前表单数据不能保存。<br>在校验规则公式框中可以使用 =, !=, <, >, >=, <= 进行组合编写规则,暂时只支持纯字段值比较，不支持字段计算后比较。</el-tag>
              <!-- 还可对关联表中的数据进行计数、求和、求平均的统计。 -->
          </el-form-item>
          <el-form-item v-if="!isSummary" label="">
              <span>1.【表单内】选择<font size="3" face="arial" color="#67C23A">当前表单</font>内的字段</span>
              <TreeSelect
                  ref="treeSelect"
                  :key="loadTimer"
                  :sourceOptions="sourceOptions"
                  @treeSelectChoose="treeSelectChoose"
                  :multiple="false"
              />
          </el-form-item>
          <el-form-item v-if="!isSummary" label="">
            <span>2.【跨表单】选择当前表单内设置的<font size="3" face="arial" color="#E6A23C">关联数据字段</font>所对应表单内的字段</span>
              <el-popover
                placement="top-start"
                width="1000"
                trigger="click">
                    <el-tabs style="height: 680px;overflow-y:auto;" :tab-position="tabPosition" @tab-click="handleClickRef">
                      <el-tab-pane
                        v-for="(conditionField, index) in linkConditionFields"
                        :key="index"
                        :label="conditionField.label"
                        :name="conditionField.formId"
                        >
                        <div  v-for="item in conditionRefFieldList" :key="item.id">
                          <el-button @click="treeSelectChoose(item)" style="margin-bottom: 8px;"  icon="el-icon-grape" type="info" size="mini" plain> {{'' +  item.name }}</el-button>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                    <!-- @click="showFormulaConditionFields(1)" -->
                 <el-button slot="reference" plain style="cursor:pointer;"  icon="el-icon-setting"  type="warning" >选择字段</el-button>
              </el-popover>
          </el-form-item>
          <el-form-item v-if="!isSummary" label="">
            <span>3.【跨表单】选择引用了当前表单作为关联数据字段的<font size="3" face="arial" color="#F56C6C">其它表单</font>内的字段</span>
             <el-popover
                placement="top-start"
                width="1000"
                trigger="click">
                    <el-tabs style="height: 680px;overflow-y:auto;" :tab-position="tabPosition" @tab-click="handleClickOther">
                      <el-tab-pane
                        v-for="(conditionField, index) in otherConditionFields"
                        :key="index"
                        :label="conditionField.label"
                        :name="conditionField.ortherFieldId"
                        >
                        <div  v-for="item in conditionOtherFieldList" :key="item.id" >
                          <el-button @click="treeSelectChoose(item)" style="margin-bottom: 8px;" icon="el-icon-cherry" type="info" size="mini" plain> {{'' +  item.name }}</el-button>
                        </div>
                      </el-tab-pane>
                    </el-tabs>
                 <el-button slot="reference" plain style="cursor:pointer;"  icon="el-icon-setting"  type="danger" >选择字段</el-button>
              </el-popover>
              <!-- <el-button plain style="cursor:pointer;"  icon="el-icon-setting" @click="showFormulaConditionFields(2)" type="danger" >选择校验规则字段</el-button> -->
          </el-form-item>
          <el-form-item v-if="isSummary" label="选择要统计的子表单">
              <TreeSelect
                  ref="treeSelect1"
                  :key="subFormLoadTimer"
                  :sourceOptions="sourceOptions"
                  @treeSelectChoose="treeSelectChoose1"
                  :multiple="false"
              />
          </el-form-item>
          <el-form-item v-if="isSummary" label="选择要统计的子表单的字段">
              <TreeSelect
                  ref="treeSelect2"
                  :key="loadTimer"
                  :sourceOptions="subSourceOptions"
                  @treeSelectChoose="treeSelectChoose"
                  :multiple="false"
              />
          </el-form-item>
          <!-- <el-form-item label="公式值">
                <div>{{content.txt}}</div>
                <el-button class="share-button" type="success" icon="el-icon-question" @click="handleSave()" circle></el-button>
          </el-form-item> -->
          <!-- <el-form-item v-if="!isSummary" label="">
              <span><font size="3" face="arial" color="#409eff">校验条件</font></span>
              <el-radio-group v-model="operateType" size="mini" class="operate-type" @change="valRuleSelectChoose">
                    <el-radio label="等于">=</el-radio>
                    <el-radio label="不等于">!=</el-radio>
                    <el-radio label="小于"><</el-radio>
                    <el-radio label="小于等于"><=</el-radio>
                    <el-radio label="大于">></el-radio>
                    <el-radio label="大于等于">>=</el-radio>
                </el-radio-group>
          </el-form-item> -->
          <el-form-item label="校验规则公式">
              <div v-if="isSummary && subFieldSelected" class="subFieldStyle">进行统计的子表单名称：{{subFieldSelected.label}}</div>
              <div class="calculationDiv">
                <contenteditable :child="content"></contenteditable>
                <!-- <m-contenteditable :child="content"></m-contenteditable> -->
                <!-- <div><pre v-html="content.txt"></pre></div> -->
              </div>
          </el-form-item>
      </el-form>
      <!-- 侧滑 -->
      <div class="bi-content-other">
          <el-drawer
            :visible.sync="isShowSearchSetting"
            title="配置默认筛选值"
            :direction="direction"
            size="20vw"
              >
                <div class="search-field" style="height: 100%;">
                    <SearchCondition
                        ref="searchConditon"
                        :key="searchLoadTimer"
                        :conditionFields="fieldList"
                        :isShowLeftModel="false"
                        :class="'search-field-box'"
                        :style="'height:82vh;overflow:auto;'"
                        >
                    </SearchCondition>
                </div>
                <div class="opt" style="position: fixed;bottom: 20px;text-align: center;left: 7vw;">
                    <el-button @click="isShowSearchSetting=false">取消</el-button>
                    <el-button type="success" @click="subSetField">确定</el-button>
                </div>
          </el-drawer>
      </div>
    </div>
</template>

<script>
import TreeSelect from '@/components/TreeSelect';
import Contenteditable from '@/components/Contenteditable';
import { getFormConfig, getFormListByMainFormId } from '@/data-model';
import { isEmpty, cloneDeep } from 'lodash';

export default {
    components: { TreeSelect, Contenteditable },
    props: {
        content: {
            type: Object,
            required: true
        },
        sourceOptions: {
            type: Array,
            default: () => { return []; }
        },
        isSummary: {
            type: Boolean,
            default: false
        },
        subFieldSelected: {
            type: Object,
            default: () => { return {}; }
        },
        field: {
            type: Object,
            required: true
        },
        fieldsList: {
            type: Array
        },
        modelData: {
            type: Object
        }
    },
    data () {
        // var _self = this;
        // window.setSearchFilter = function () {
        //     console.log(_self);
        //     // console.log(id);
        // };
        return {
            tabPosition: 'left',
            isShowFormulaConditionFields: false,
            subSourceOptions: [],
            subFormLoadTimer: '',
            loadTimer: '',
            linkConditionFields: [],
            otherConditionFields: [],
            conditionRefFieldList: [],
            conditionOtherFieldList: [],
            conditionFieldListMap: new Map(),
            otherConditionFieldListMap: new Map(),
            searchLoadTimer: '',
            isShowSearchSetting: false,
            fieldList: undefined,
            direction: 'ltr',
            operateType: ''
        };
    },
    created () {
        this.subFormLoadTimer = new Date().getTime();
        this.loadTimer = new Date().getTime();
        this.conditionFieldListMap = new Map();
        this.otherConditionFieldListMap = new Map();
        this.initConditionFields();
        let _this = this;
        window.setSearchFilter = _this.setSearchFilter;
    },
    methods: {
        treeSelectChoose1 (selected) { // 选择好数据源后
            this.subFieldSelected = selected;
            this.subSourceOptions = selected.subFieldList;
            this.content.txt = '';
            this.loadTimer = new Date().getTime();
        },
        treeSelectChoose (selected) { // 选择好数据源后
            // console.log(selected);
            this.content.txt = this.content.txt + "  <input style='color:black;font-weight:600;width:" + this.getWidth(selected.label) + "px;' type='button' onclick='setSearchFilter(\"" + selected.id + '",' + selected.calType + ',"' + selected.formId + "\");' flg='" + selected.type + "' class='elementdata' id='" + selected.id + "' value='" + selected.label + "'/>";
        },
        valRuleSelectChoose (selected) { // 选择好数据源后
            // console.log(selected);
            this.content.txt = this.content.txt + selected;
        },
        transformFormula () {
            let formula = this.content.txt.trim();
            formula = formula.replace(/&nbsp;/g, '');// 去除html空格
            formula = this.designFormula(formula).trim();// 遍历替换校验规则元素
            formula = formula.replace(/&gt;/g, '>');// 替换大于符号
            formula = formula.replace(/&lt;/g, '<');// 替换小于符号
            // console.log("=====================");
            // console.log(formula);
            return formula;
        },
        designFormula (formula) { // 遍历公式编辑器，设计出最后的公式
            if (formula.indexOf('<input') !== -1) {
                let startIdx = formula.indexOf('<input');
                let endIdx = formula.indexOf('>');
                let inputData = formula.substring(startIdx, endIdx + 1);
                // console.log(inputData);
                startIdx = inputData.indexOf('flg=') + 5;
                endIdx = startIdx + 1;
                let type = inputData.substring(startIdx, endIdx);
                // console.log(type);
                let idLen = 0;
                if (type === '3') { // // 跨表单字段，xxx,xxx,xxx,cnt 第一个是表单id,第二个是目标表单内统计的字段id(计数时与refFieldId一致)，第三个是目标表单与当前表单的关联字段id,第四个是校验规则公式（cnt:计数 sum:求和 avg:平均）
                    idLen = 102;
                } else if (type === '2') { // 跨表单字段，xxx;xxx;xxx 第一个是当前表单内关联字段id,第二个是被关联表单内选择校验规则的字段id,第三个是被关联表单id
                    idLen = 98;
                } else if (type === '1') { // 已有的元素
                    idLen = 32;
                } else { // 新增的元素
                    idLen = 16;
                }
                // console.log(idLen);
                startIdx = inputData.indexOf('id=') + 4;
                endIdx = startIdx + idLen;
                let id = inputData.substring(startIdx, endIdx);
                // console.log(id);
                formula = formula.replace(inputData, id);
                // console.log(formula);
                formula = this.designFormula(formula);
            }
            return formula;
        },
        /*
        * 假如待选变量：  ID,NUM,TOTAL，AVL TEST
        * 正确的公式例子：ID*NUM+(TOTAL/AVL)*0.5
        * 错误的公式例子：ID**|0.5
        */
        checkFormula (string, obj) { // TOOD:后续补上数学公式的校验
            // 剔除空白符
            string = string.replace(/\s/g, '');
            // 错误情况，空字符串
            if (string === '') {
                return false;
            }
            // 错误情况，运算符连续
            if (/[\+\-\*\/]{2,}/.test(string)) {
                return false;
            }
            // 空括号
            if (/\(\)/.test(string)) {
                return false;
            }
            // 错误情况，括号不配对
            var stack = [];
            for (var i = 0, item; i < string.length; i++) {
                item = string.charAt(i);
                if (item === '(') {
                    stack.push('(');
                } else if (item === ')') {
                    if (stack.length > 0) {
                        stack.pop();
                    } else {
                        return false;
                    }
                }
            }
            if (stack.length !== 0) {
                return false;
            }
            // 错误情况，(后面是运算符
            if (/\([\+\-\*\/]/.test(string)) {
                return false;
            }
            // 错误情况，)前面是运算符
            if (/[\+\-\*\/]\)/.test(string)) {
                return false;
            }
            // 错误情况，(前面不是运算符
            if (/[^\+\-\*\/]\(/.test(string)) {
                return false;
            }
            // 错误情况，)后面不是运算符
            if (/\)[^\+\-\*\/]/.test(string)) {
                return false;
            }
            // 错误情况，变量没有来自“待选公式变量”
            var tmpStr = string.replace(/[\(\)\+\-\*\/]{1,}/g, '`');
            var array = tmpStr.split('`');
            for (let i = 0, item; i < array.length; i++) {
                item = array[i];
                if (/[A-Z]/i.test(item) && typeof (obj[item]) === 'undefined') {
                    return false;
                }
            }
            return true;
        },
        async chooseConditionFields () {
            this.isShowFormulaConditionFields = false;
            this.otherConditionFields = this.$refs.formulaConditionFields.getConditionFields();
            // console.log(this.otherConditionFields);
        },
        showFormulaConditionFields (type) {
            // console.log(type);
            this.isShowFormulaConditionFields = true;
        },
        handleClickRef (tab, event) {
            // console.log(tab, event);
            // this.getFormModel(tab.name);
            if (this.conditionFieldListMap.has(tab.name)) {
                this.conditionRefFieldList = this.conditionFieldListMap.get(tab.name).filterList;
            }
        },
        handleClickOther (tab, event) {
            // console.log(tab, event);
            // this.getFormModel(tab.name);
            if (this.otherConditionFieldListMap.has(tab.name)) {
                this.conditionOtherFieldList = this.otherConditionFieldListMap.get(tab.name).filterList;
            }
        },
        async getFormModel (refFieldId, formId, type, keyFieldId) {
            let resData = await getFormConfig(formId);
            let filterList = [];
            let isFirst = true;
            if (!isEmpty(resData && resData.fieldsList)) {
                resData.fieldsList.forEach(item => {
                    if (item.type === 'number' || item.type === 'calculation' || item.type === 'subFormSummary') { // 仅支持数字类型的字段进行校验规则公式设计
                        item.calType = type;
                        item.formId = formId;
                        let cloneObj = cloneDeep(item);
                        cloneObj.type = type;
                        if (type === 2) { //  跨表单字段，xxx;xxx;xxx 第一个是当前表单内关联字段id,第二个是被关联表单内选择校验规则的字段id,第三个是被关联表单id
                            cloneObj.id = refFieldId + ';' + item.id + ';' + formId;
                            cloneObj.label = '([' + resData.formName + '].{' + item.name + '})';
                            filterList.push(cloneObj);
                        } else if (type === 3) { // 跨表单字段，xxx,xxx,xxx,cnt 第一个是表单id,第二个是目标表单内统计的字段id(计数时与refFieldId一致)，第三个是目标表单与当前表单的关联字段id,第四个是校验规则公式（cnt:计数 sum:求和 avg:平均）
                            if (isFirst) {
                                cloneObj.id = formId + ',' + refFieldId + ',' + refFieldId + ',cnt';
                                cloneObj.name = '计数cnt([' + resData.formName + '])';
                                cloneObj.label = cloneObj.name;
                                filterList.push(cloneObj);
                                isFirst = false;
                            }
                            let cloneObj2 = cloneDeep(cloneObj);
                            cloneObj2.name = '求和sum([' + resData.formName + '].{' + item.name + '})';
                            cloneObj2.label = cloneObj2.name;
                            cloneObj2.id = formId + ',' + item.id + ',' + keyFieldId + ',sum';
                            filterList.push(cloneObj2);
                            let cloneObj3 = cloneDeep(cloneObj);
                            cloneObj3.name = '平均avg([' + resData.formName + '].{' + item.name + '})';
                            cloneObj3.label = cloneObj3.name;
                            cloneObj3.id = formId + ',' + item.id + ',' + keyFieldId + ',avg';
                            filterList.push(cloneObj3);
                        }
                    }
                });
                let obj = {
                    formName: resData.formName,
                    filterList: filterList
                };
                if (type === 2) {
                    this.conditionFieldListMap.set(formId, obj);
                } else if (type === 3) {
                    this.otherConditionFieldListMap.set(keyFieldId, obj);
                }
            }
        },
        async initConditionFields () {
            // console.log(this.field);
            // console.log(this.fieldsList);
            this.linkConditionFields = [];
            if (!isEmpty(this.fieldsList)) {
                for (let i = 0; i < this.fieldsList.length; i++) {
                    let item = this.fieldsList[i];
                    if (item.type === 'link') {
                        if (item.options.config.form && !isEmpty(item.options.config.form.formId)) {
                            let temFormId = item.options.config.form.formId;
                            await this.getFormModel(item.id, temFormId, 2);
                            let tempFormName = '';
                            if (this.conditionFieldListMap.has(temFormId)) {
                                tempFormName = this.conditionFieldListMap.get(temFormId).formName;
                            }
                            let conditionField = {
                                label: '字段<' + item.name + '>来源于【' + tempFormName + '】表',
                                formId: temFormId
                            };
                            this.linkConditionFields.push(conditionField);
                        }
                    }
                }
                this.otherConditionFields = [];
                if (this.modelData.formId) {
                    let otherForms = await getFormListByMainFormId(this.modelData.formId);
                    if (otherForms && Array.isArray(otherForms)) {
                        for (let j = 0; j < otherForms.length; j++) {
                            let otherForm = otherForms[j];
                            let conditionField = {
                                label: '【' + otherForm.formName + '】表的字段<' + otherForm.ortherFieldName + '>引用了当前表单',
                                formId: otherForm.id,
                                ortherFieldId: otherForm.ortherFieldId
                            };
                            this.otherConditionFields.push(conditionField);
                            await this.getFormModel(otherForm.ortherFieldId, otherForm.id, 3, otherForm.ortherFieldId);
                        }
                    }
                }
            }
        },
        countWordCnt (data) {
            var len = 0;
            for (var i = 0; i < data.length; i++) {
                var a = data.charAt(i);
                if (a.match(/[^\x00-\xff]/ig) != null) {
                    len += 2;
                } else {
                    len += 1;
                }
            }
            return len;
        },
        getWidth (labelValue) {
            let len = this.countWordCnt(labelValue);
            if (len < 8) {
                return 64;
            } else {
                return len * 8;
            }
        },
        async setSearchFilter (fieldId, calType, formId) {
            await this.getFormDetail(formId);
            this.searchLoadTimer = new Date().getTime();
            this.isShowSearchSetting = true;
        },
        subSetField () {
            // this.field.ext1 = JSON.stringify(this.fieldList);
            // TODO: 这里根据不同的字段进行过滤条件的补充，在进行公式校验规则的时候使用条件进行过滤
            this.isShowSearchSetting = false;
        },
        async getFormDetail (formId) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const { fieldsList } = await getFormConfig(formId);
            this.fieldList = fieldsList;
            // TODO: 这里根据不同的字段进行过滤条件的补充，在进行公式校验规则的时候使用条件进行过滤
            // if (this.fieldList && this.fieldList.length > 0) {
            //     this.filtFields = [];
            //     if (!isEmpty(this.field.ext1)) {
            //         this.defFilt = JSON.parse(this.field.ext1);
            //         if (this.field.ext1) {
            //             this.fieldList = JSON.parse(this.field.ext1);
            //         }
            //     }
            // }
            loading.close();
        }
    }
};
</script>

<style lang="less">
.formulaValidationClass{
  .content{
    background: gray;
    height: 300px;
    color: #fff;
    }
  div[contenteditable]:empty:not(:focus):before {
    content: attr(placeholder);
    color: #aaa ;
  }
  .box {
    width: 100%;
    height: 100px;
  }

  .elementdata{
    font-style:normal;
    // width:100px;
    border: 1px solid #eeecec;
    background-color: #fcfcfd;
    cursor: pointer;
    display: inline-block;
    height: 22px;
    line-height: 22px;
    box-sizing: border-box;
    overflow: hidden;
    margin: 2px;
  }
  .calculationDiv{
      padding: 10px;
      border: 1px solid #d5d5d5;
      box-sizing: border-box;
      height: 130px;
      overflow-y: auto;
      background: #fff;
      box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
      font-family: Liberation Mono,LiberationMonoRegular,Courier New,monospace!important;
  }
    .subFieldStyle {
        font-size: 10px;
        color: #777;
    }
}

</style>



// WEBPACK FOOTER //
// src/components/Formula/FormulaValidation.vue